export default __webpack_public_path__ + "static/media/StakingIcon.16935153.png";